// extracted by mini-css-extract-plugin
module.exports = {"productSlider":"ProductTactics_productSlider__li9ZJ","slider":"ProductTactics_slider__opwPj"};